import React, { useState } from "react";
import { FormControl, SelectPicker } from "rsuite";

import {
    CenteredForm,
    GlobalStyle,
    StyledContainerRow,
    StyledFormStretched,
    StyledLabel,
} from "./TrunkFormRefactored.styles";

const IvrFormSection = ({ formRef, isMobile, ivr_list, disabled, initialValues }) => {
    const ivrData = ivr_list.map(ivr => {
        return {
            value: ivr.id,
            label: ivr.name
        };
    });
    const emptyIvr = {
        value: null,
        label: ""
    };

    const [currentIvr, setCurrentIvr] = useState(initialValues.ivr_id);

    const sortedIvrList = [...ivrData, emptyIvr];
    sortedIvrList.sort((a, b) => {
        if (a.label > b.label) return 1;
        if (a.label < b.label) return -1;
        return 0;
    });

    return (
        <>
            <GlobalStyle />
            <CenteredForm
                ref={formRef}
                formDefaultValue={{ ...initialValues }}
                style={{ width: "100%" }}
            >
                <StyledFormStretched>
                    <div className="column">
                        <StyledContainerRow>
                            <StyledLabel display="block" compact width={100}>Select IVR</StyledLabel>
                            <FormControl
                                className="ivr_select"
                                accepter={SelectPicker}
                                data={sortedIvrList}
                                name="ivr_id"
                                onChange={(value) => {
                                    setCurrentIvr(value);
                                }}
                                value={currentIvr}
                                disabled={disabled}
                                cleanable={false}
                                placement={isMobile ? "topEnd" : "bottomStart"}
                                placeholder={<>&#8203;</>}
                                {...(!isMobile ? { width: 300 } : {})}
                            />
                        </StyledContainerRow>
                    </div>
                </StyledFormStretched>
            </CenteredForm>
        </>
    );
};

export default IvrFormSection;
